import { render, staticRenderFns } from "./addNewExaminer.vue?vue&type=template&id=3f3c160c&"
import script from "./addNewExaminer.vue?vue&type=script&lang=js&"
export * from "./addNewExaminer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports